// eslint-disable-next-line import/prefer-default-export
export const OPACITY = {
  none: 0,
  disabled: 0.6,
  half: 0.5,
} as const;
